/**
 * Premium loading skeletons that match the real VantStride card shapes.
 * Prevents the "large blank area" perception during initial data load.
 */

function shimmer() {
  return "animate-pulse bg-gradient-to-r from-slate-100 via-slate-200 to-slate-100 bg-[length:200%_100%]";
}

export function HubCardSkeleton() {
  return (
    <div
      className="rounded-3xl overflow-hidden border border-slate-100 bg-white"
      data-testid="hub-card-skeleton"
      aria-hidden
    >
      <div className={`h-40 ${shimmer()}`} />
      <div className="p-6 space-y-3">
        <div className={`h-3 w-4/5 rounded ${shimmer()}`} />
        <div className={`h-3 w-3/5 rounded ${shimmer()}`} />
        <div className="flex gap-1.5 pt-2">
          <div className={`h-5 w-16 rounded-full ${shimmer()}`} />
          <div className={`h-5 w-20 rounded-full ${shimmer()}`} />
          <div className={`h-5 w-14 rounded-full ${shimmer()}`} />
        </div>
        <div className={`h-3 w-24 rounded mt-4 ${shimmer()}`} />
      </div>
    </div>
  );
}

export function HubCardSkeletonGrid({ count = 6 }) {
  return (
    <div
      className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5"
      data-testid="hub-skeleton-grid"
    >
      {Array.from({ length: count }).map((_, i) => (
        <HubCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function ResourceCardSkeleton() {
  return (
    <div
      className="rounded-3xl border border-slate-100 bg-white p-7"
      data-testid="resource-card-skeleton"
      aria-hidden
    >
      <div className="flex items-center justify-between">
        <div className={`h-5 w-24 rounded-full ${shimmer()}`} />
        <div className={`h-8 w-8 rounded-full ${shimmer()}`} />
      </div>
      <div className={`h-5 w-3/4 rounded mt-5 ${shimmer()}`} />
      <div className={`h-3 w-full rounded mt-4 ${shimmer()}`} />
      <div className={`h-3 w-5/6 rounded mt-2 ${shimmer()}`} />
      <div className={`h-3 w-2/3 rounded mt-2 ${shimmer()}`} />
      <div className={`h-10 w-full rounded-full mt-6 ${shimmer()}`} />
    </div>
  );
}

export function ResourceCardSkeletonGrid({ count = 6 }) {
  return (
    <div
      className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5"
      data-testid="resource-skeleton-grid"
    >
      {Array.from({ length: count }).map((_, i) => (
        <ResourceCardSkeleton key={i} />
      ))}
    </div>
  );
}
